/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//Import Alert
import { toast } from "react-toastify";

//import Moment JS
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// moment.defineLocale("th-foo", {
//   parentLocale: "th",
//   /* */
// });
// moment.updateLocale("th", null);

// Import Form
import { Form, Col, Row, FormControl, Button } from "react-bootstrap";

/* eslint-enable */

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Import Modal
import Modal from "react-bootstrap/Modal";

//Import Accordion
import Accordion from "react-bootstrap/Accordion";

//Import Tab
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

//Import Form
import FormUpload from "./FormUpload";

//Import service
import academyService from "../../services/academy.service";
import FarmerService from "../../services/farmer.service";
import userService from "../../services/user.service";
import RegsugarService from "../../services/regsugar.service";
import authService from "../../services/auth.service";
import farmermasterService from "../../services/farmermaster.service";
import farmerService from "../../services/farmer.service";

import Profile from "./Profile";

//Import CSS
import "./Modaladddetail.css";

function ModalAddDetail(props) {
  const [assoc, setAssoc] = useState([
    {
      association_id: "1",
      association_name_th: "ไม่ระบุสถาบัน",
    },
  ]);
  const [farmer, setFarmer] = useState({});
  const [assocselected, setAssocSelected] = useState({
    association_id: "1",
    association_name_th: "ไม่ระบุสถาบัน",
  });
  const [key, setKey] = useState("direct");
  const [factory, setFactory] = useState([]);
  const [form, setForm] = useState({ deed_rent: "เช่า" });
  const [errors, setErrors] = useState({});
  const [mastersent, setMastersent] = useState([]);
  const [directsent, setDirectsent] = useState([]);
  const [plant, setPlant] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showuploadform, setShowuploadform] = useState(false);
  const [regid, setRegid] = useState(0);
  const [toggle, setToggle] = useState(true);
  const [refreshImg, setRefreshImg] = useState(true);
  const [approveStatus, setApproveStatus] = useState("ฉบับร่าง");

  const [industryStatus, setIndustryStatus] = useState("false");

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setIndustryStatus(checked ? value : "false"); // ถ้าเลือกให้เก็บค่า, ถ้ายกเลิกให้ล้างค่า
  };

  const renderTooltip = (props) => (
    <Tooltip {...props}>คลิ๊ก เปิด-ปิด แก้ไขข้อมูล</Tooltip>
  );

  const checkID = (id) => {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  const autoGetMasterName = (person_card) => {
    farmermasterService.getFarmerByPersonCard(person_card).then((response) => {
      if (response.data.success) {
        setForm({
          ...form,
          ["master_fullname"]: response.data.data.master_name,
        });
      }
    });
  };

  const setDeed = (field, value) => {
    if (field.name === "deed_idcard_number") {
      if (checkID(value)) {
        farmerService.getFarmerById(value).then((res) => {
          if (res.data.success) {
            const fullname =
              res.data.farmer.pre_name +
              " " +
              res.data.farmer.first_name +
              " " +
              res.data.farmer.last_name;
            setForm((a) => ({ ...a, ["deed_name"]: fullname }));
          }
        });
      }
    }
    setForm({
      ...form,
      [field.name]: value,
    });
    setErrors({
      ...errors,
      [field.name]: null,
    });
  };
  const setApprove_Status = (value) => {
    setApproveStatus(value);
  };

  const setField = (field, value) => {
    if (field.name == "master_id") {
      if (value.length < 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขไม่ครบ" });
      } else if (value.length > 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขเกิน" });
      } else if (!checkID(value)) {
        setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
      } else {
        autoGetMasterName(value);
        setErrors({ ...errors, [field.name]: null });
      }
    } else {
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
    if (field.name == "factory") {
      let index = field.selectedIndex;
      let label = field[index].text;
      setForm({
        ...form,
        [field.name]: { factory_id: value, factory_name: label },
      });
    } else if (field.name == "factory_h") {
      let index = field.selectedIndex;
      let label = field[index].text;
      setForm({
        ...form,
        [field.name]: { factory_id: value, factory_name: label },
      });
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
    }
  };
  const findDirectErrors = () => {
    const { factory, direct_sent } = form;
    const newErrors = {};

    // start date errors
    if (!factory || factory.factory_id == "")
      newErrors.factory = "กรุณากรอกโรงงาน";

    if (!direct_sent || direct_sent === "")
      newErrors.direct_sent = "กรุณากรอกโรงงาน";

    return newErrors;
  };

  const findDeedErrors = () => {
    const { deed_type, deed_rent, deed_idcard_number } = form;
    const newErrors = {};

    // start date errors
    if (!deed_idcard_number || deed_idcard_number == "") {
      newErrors.deed_idcard_number = "กรุณากรอกบัตรประชาชน";
    } else if (!checkID(deed_idcard_number)) {
      newErrors.deed_idcard_number = "กรอกบัตรประชาชนไม่ถูกต้อง";
    }

    if (!deed_type || deed_type == "")
      newErrors.deed_type = "กรุณาเลือกการเช่า";
    if (!deed_rent || deed_rent == "")
      newErrors.deed_rent = "กรุณาเลือกการเช่า";
    return newErrors;
  };

  const findMasterErrors = () => {
    const { master_id, master_fullname, master_sent, factory_h } = form;
    const newErrors = {};

    if (!factory_h || factory_h.factory_id == "")
      newErrors.factory_h = "กรุณากรอกโรงงาน";

    if (!master_id || master_id === "")
      newErrors.master_id = "กรุณากรอกเลขบัตรประชาชน";

    if (!master_fullname || master_fullname === "")
      newErrors.master_fullname = "กรุณากรอกชื่อ-สกุล";

    if (!master_sent || master_sent === "")
      newErrors.master_sent = "กรุณากรอกจำนวนอ้อย";

    return newErrors;
  };
  useEffect(() => {
    initialForm();
  }, [props.show]);

  const initialForm = () => {
    setPlant([]);
    setApproveStatus("ฉบับร่าง");
    setMastersent([]);
    setDirectsent([]);
    setForm({
      deed_rent: "เช่า",
    });
    setAssoc([
      {
        association_id: "1",
        association_name_th: "ไม่ระบุสถาบัน",
      },
    ]);
    setAssocSelected({
      association_id: "1",
      association_name_th: "ไม่ระบุสถาบัน",
    });
  };
  const handleClose = () => {
    initialForm();
    props.hidden(false);
    setToggle(true);
  };
  const getMember = (farmer_idcard) => {
    academyService.getAcademyByPersonId(farmer_idcard).then((data) => {
      if (data.data?.success && data.data?.data?.length > 0) {
        setAssoc(data.data.data);
      }
    });
  };
  const getFarmer = (farmer_idcard) => {
    FarmerService.getFarmerById(farmer_idcard).then((data) => {
      setFarmer(data.data.farmer);
    });
  };

  const getFactory = () => {
    userService
      .getFactorylist()
      .then((response) => {
        setFactory(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
  };

  useEffect(() => {
    if (props.farmer_idcard != 0) {
      getMember(props.farmer_idcard);
      getFarmer(props.farmer_idcard);
    }

    getFactory();
  }, [props.farmer_idcard]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const user = authService.getCurrentUser();
    setLoading(true);
    RegsugarService.createRegsugar({
      ...farmer,
      approve_status: approveStatus,
      assoc: assoc,
      mastersent: mastersent,
      directsent: directsent,
      ...props.selectdata,
      user_id: user.user.user_id,
      reg_code: user.user.user_reg,
      deed: plant,
    })
      .then((response) => {
        props.setdata([response.data.data, ...props.data]);
        props.hidden(false);
        toast.success("บันทึกข้อมูลเรียบร้อย");
        setShowuploadform(true);
        setRegid(parseInt(response.data.data.regsugar_id));
      })
      .catch((error) => {
        toast.error("error create data: ", error);
      })
      .finally(() => {
        setLoading(false);
        initialForm();
      });
  };

  const setAssocSelect = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let value = e.target.value;
    setAssocSelected({
      association_id: value,
      association_name_th: label,
    });
  };

  const clickAddAssoc = (e) => {
    e.preventDefault();
    if (assocselected.association_id !== "1") {
      setAssoc([
        ...assoc.filter(
          (a) =>
            a.association_id != assocselected.association_id &&
            a.association_id != "1"
        ),
        assocselected,
      ]);
    } else {
      setAssoc([
        {
          association_id: "1",
          association_name_th: "ไม่ระบุสถาบัน",
        },
      ]);
    }
  };

  const handleRemoveItem = (id) => {
    setAssoc(assoc.filter((item) => item.association_id !== id));
  };

  const handleRemoveItemMaster = (id) => {
    setMastersent(mastersent.filter((item) => item.master_id !== id));
  };

  const handleRemoveItemDirect = (id) => {
    setDirectsent(directsent.filter((item) => item.factory_id !== id));
  };

  const handleRemoveItemPlant = (dee_key) => {
    setPlant(plant.filter((item, key) => key !== dee_key));
  };

  const handleAddMaster = (e) => {
    e.preventDefault();
    const newErrors = findMasterErrors();
    if (
      newErrors.master_id ||
      newErrors.master_fullname ||
      newErrors.master_sent ||
      newErrors.factory_h
    ) {
      setErrors(newErrors);
    } else {
      const masterfilter = mastersent.filter(
        (item) => item.master_id != form.master_id
      );
      setMastersent([
        ...masterfilter,
        {
          master_id: form.master_id,
          master_fullname: form.master_fullname,
          master_sent: form.master_sent,
          master_factory_id: form.factory_h.factory_id,
          master_factory_name: form.factory_h.factory_name,
        },
      ]);
      setForm({
        ...form,
        master_id: "",
        master_fullname: "",
        master_sent: "",
        factory_h: { factory_id: "", factory_name: "" },
      });
    }
  };

  const handleAddDirect = (e) => {
    e.preventDefault();
    const newErrors = findDirectErrors();
    if (newErrors.direct_sent || newErrors.factory) {
      setErrors(newErrors);
    } else {
      const directfilter = directsent.filter(
        (item) => item.factory_id != form.factory.factory_id
      );
      setDirectsent([
        ...directfilter,
        {
          factory_id: form.factory.factory_id,
          factory_name: form.factory.factory_name,
          direct_sent: form.direct_sent,
        },
      ]);
      setForm({
        ...form,
        factory: {
          factory_id: "",
          factory_name: "",
        },
        direct_sent: "",
      });
    }
  };

  const handleAddPlant = (e) => {
    e.preventDefault();
    const newErrors = findDeedErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setPlant([
        ...plant,
        {
          deed_number: form.deed_number,
          deed_idcard_number: form.deed_idcard_number,
          deed_type: form.deed_type,
          deed_rent: form.deed_rent ? form.deed_rent : "-",
          deed_name: form.deed_name ? form.deed_name : "-",
          deed_rai: form.deed_rai ? form.deed_rai : 0,
        },
      ]);
      setForm({
        ...form,
        deed_idcard_number: "",
        deed_number: "",
        deed_type: "",
        deed_rent: "",
        deed_name: "",
        deed_rai: "",
      });
    }
  };

  const afterSaveFarmer = (item) => {
    setRefreshImg(false);
    setFarmer({
      id_card: item.farmer_idcard,
      pre_name: item.farmer_nametitle,
      first_name: item.farmer_name,
      last_name: item.farmer_lastname,
      prov_namt: item.masterLocation.provinceDesc,
      amp_namt: item.masterLocation.districtDesc,
      tam_namt: item.masterLocation.subdistrictDesc,
      sex: item.farmer_gender,
      tel: item.farmer_phone,
      address: item.farmer_address,
      birth_date: item.farmer_birthday,
      farmer_image: item.farmer_image,
      farmer_id: item.farmer_id,
      cwt: item.masterLocation.provinceCode,
      region: item.region_id,
    });
    setRefreshImg(true);
  };

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <FormUpload
        show={showuploadform}
        hidden_func={(a) => setShowuploadform(a)}
        regid={regid}
      />
      <Modal size="xl" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มข้อมูลการจดทะเบียน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>ข้อมูลพื้นฐาน</Accordion.Header>
              <Accordion.Body>
                <Profile
                  hidden={toggle}
                  farmer_idcard={props.farmer_idcard ? props.farmer_idcard : 0}
                  aftersubmit={afterSaveFarmer}
                  toggle={() => setToggle((a) => !a)}
                />
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <i
                    className="bi bi-pencil"
                    onClick={() => setToggle((a) => !a)}
                  ></i>
                </OverlayTrigger>
                <br />
                <div className="container farmer-profile">
                  <div className="farmer-profile-img">
                    <img
                      src={
                        refreshImg
                          ? process.env.REACT_APP_API +
                            "/images/farmer/" +
                            farmer.farmer_image +
                            "?" +
                            new Date().getTime()
                          : ""
                      }
                      alt="dummy"
                      width="150"
                      height="150"
                    />
                  </div>
                  <br />
                  <span>ชื่อ - นามสกุล : </span>{" "}
                  {farmer.pre_name +
                    " " +
                    farmer.first_name +
                    " " +
                    farmer.last_name}
                  <br />
                  <span>ที่อยู่ : </span>{" "}
                  {farmer.address +
                    " แขวง/ตำบล " +
                    farmer.tam_namt +
                    " เขต/อำเภอ " +
                    farmer.amp_namt +
                    " จังหวัด " +
                    farmer.prov_namt}
                  <br />
                  <span>เพศ : </span>
                  {farmer.sex}
                  <br />
                  <span>วันเกิด : </span>
                  {moment(farmer.birth_date)
                    .add(543, "year")
                    .locale("th")
                    .format("ll")}
                  <br />
                  <span>เบอร์โทร : </span>
                  {farmer.tel}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>ข้อมูลการเป็นสมาชิกสถาบัน</Accordion.Header>
              <Accordion.Body>
                <Form>
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Select
                          name="acdemy"
                          value={assocselected.association_id}
                          onChange={(e) => setAssocSelect(e)}
                          // isInvalid={!!errors.academy}
                        >
                          <option key={1} value={1}>
                            ไม่ระบุสถาบัน
                          </option>
                          {props.academy.map((o) => (
                            <option key={o.academyId} value={o.academyId}>
                              {o.academyName}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <button
                          className="btn btn-primary btn-add-detail"
                          onClick={clickAddAssoc}
                        >
                          เพิ่ม
                        </button>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                {assoc.map((item) => {
                  return (
                    <div key={item.association_id}>
                      <li
                        className="cademy-ui"
                        key={item.association_id}
                        name={item.association_id}
                      >
                        {item.association_name_th}
                        <i
                          className="bi bi-x"
                          key={item.association_id}
                          onClick={() => handleRemoveItem(item.association_id)}
                          style={{ color: "red" }}
                        ></i>
                      </li>
                    </div>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>ข้อมูลการส่งอ้อย</Accordion.Header>
              <Accordion.Body>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3"
                >
                  <Tab eventKey="direct" title="ส่งตรงโรงงาน">
                    <Row>
                      <Col md={5}>
                        <Form.Group>
                          {/* <Form.Label>เลือกโรงงาน</Form.Label> */}
                          <Form.Select
                            name="factory"
                            value={form.factory ? form.factory.factory_id : ""}
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.factory}
                          >
                            <option key={""} value="">
                              เลือกโรงงาน
                            </option>
                            {factory.map((o) => (
                              <option key={o.factoryId} value={o.factoryId}>
                                {o.factoryCode + "-" + o.factoryName}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          {/* <Form.Label>จำนวนอ้อยที่ส่ง/ตัน</Form.Label> */}
                          <FormControl
                            placeholder="จำนวนอ้อยที่ส่ง หน่วยเป็นตัน"
                            type="number"
                            name="direct_sent"
                            value={form.direct_sent}
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.direct_sent}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.direct_sent}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <button
                            className="btn btn-primary btn-add-detail"
                            onClick={handleAddDirect}
                          >
                            เพิ่ม
                          </button>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      {directsent.map((item) => {
                        return (
                          <div key={item.factory_id}>
                            <li
                              className="cademy-ui"
                              key={item.factory_id}
                              name={item.factory_id}
                            >
                              {" ชื่อโรงงาน : " +
                                item.factory_name +
                                " ส่งอ้อย : " +
                                item.direct_sent +
                                " ตัน"}
                              <i
                                className="bi bi-x"
                                key={item.factory_id}
                                onClick={() =>
                                  handleRemoveItemDirect(item.factory_id)
                                }
                                style={{ color: "red" }}
                              ></i>
                            </li>
                          </div>
                        );
                      })}
                    </Row>
                  </Tab>
                  <Tab eventKey="passMaster" title="ส่งผ่านหัวหน้ากลุ่ม">
                    <Row>
                      <Col md={2}>
                        <Form.Group>
                          <FormControl
                            placeholder="บัตรประชาชน"
                            type="number"
                            name="master_id"
                            value={form.master_id}
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.master_id}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.master_id}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group>
                          <FormControl
                            placeholder="ชื่อ - นามสกุล"
                            type="text"
                            name="master_fullname"
                            value={form.master_fullname}
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.master_fullname}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.master_fullname}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <FormControl
                            placeholder="จำนวนอ้อย/ตัน"
                            type="number"
                            name="master_sent"
                            value={form.master_sent}
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.master_sent}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.master_sent}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Select
                            name="factory_h"
                            value={
                              form.factory_h ? form.factory_h.factory_id : ""
                            }
                            onChange={(e) => setField(e.target, e.target.value)}
                            isInvalid={!!errors.factory_h}
                          >
                            <option key={""} value="">
                              เลือกโรงงาน
                            </option>
                            {factory.map((o) => (
                              <option key={o.factoryId} value={o.factoryId}>
                                {o.factoryCode + "-" + o.factoryName}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md="auto">
                        <Form.Group>
                          <button
                            className="btn btn-primary btn-add-detail"
                            onClick={handleAddMaster}
                          >
                            เพิ่ม
                          </button>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      {mastersent.map((item) => {
                        return (
                          <div key={item.master_id}>
                            <li
                              className="cademy-ui"
                              key={item.master_id}
                              name={item.master_id}
                            >
                              {item.master_id +
                                " ชื่อ - สกุล : " +
                                item.master_fullname +
                                " ส่งอ้อย : " +
                                item.master_factory_name +
                                " จำนวน " +
                                item.master_sent +
                                " ตัน"}
                              <i
                                className="bi bi-x"
                                key={item.master_id}
                                onClick={() =>
                                  handleRemoveItemMaster(item.master_id)
                                }
                                style={{ color: "red" }}
                              ></i>
                            </li>
                          </div>
                        );
                      })}
                    </Row>
                  </Tab>
                </Tabs>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>ข้อมูลที่ดิน</Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>ประเภทที่ดิน</Form.Label> */}
                      <Form.Select
                        name="deed_type"
                        value={form.deed_type}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_type}
                      >
                        <option key="" value="">
                          เลือกประเภทที่ดิน
                        </option>
                        <option key="โฉนดที่ดิน" value="โฉนดที่ดิน">
                          โฉนดที่ดิน
                        </option>
                        <option key="โฉนดที่ดิน" value="นส3ก">
                          นส3ก
                        </option>
                        <option key="โฉนดที่ดิน" value="นส3ข">
                          นส3ข
                        </option>
                        <option
                          key="โฉนดที่ดิน"
                          value="แบบแจ้งการครอบครอบที่ดิน ส.ค.1"
                        >
                          แบบแจ้งการครอบครอบที่ดิน ส.ค.1
                        </option>
                        <option key="โฉนดที่ดิน" value="สปก.">
                          สปก.
                        </option>
                        <option key="โฉนดที่ดิน" value="ภ.บ.ท.5">
                          ภ.บ.ท.5
                        </option>
                        <option key="โฉนดที่ดิน" value="สัญญาเช่าที่ดิน">
                          สัญญาเช่าที่ดิน
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_type}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>เลขที่อ้างอิงเอกสารที่ดิน</Form.Label> */}
                      <FormControl
                        placeholder="เลขอ้างอิงเอกสารที่ดิน"
                        type="text"
                        name="deed_number"
                        value={form.deed_number}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-2">
                      <Form.Check type="radio" id="check-api-radio">
                        <Form.Check.Label>ที่ดิน :{"  "}</Form.Check.Label>
                        <Form.Check.Input
                          name="deed_rent"
                          type="radio"
                          value="ไม่เช่า"
                          style={{ margin: "2px 10px" }}
                          onChange={(e) => setDeed(e.target, e.target.value)}
                        />
                        <Form.Check.Label>ไม่เช่า</Form.Check.Label>

                        <Form.Check.Input
                          name="deed_rent"
                          type="radio"
                          value="เช่า"
                          checked={form.deed_rent === "เช่า"}
                          style={{ margin: "2px 10px" }}
                          onChange={(e) => setDeed(e.target, e.target.value)}
                        />
                        <Form.Check.Label>เช่า</Form.Check.Label>
                        <Form.Control.Feedback type="invalid">
                          {errors.deed_rent}
                        </Form.Control.Feedback>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>ชื่อเจ้าของที่ดิน</Form.Label> */}
                      <FormControl
                        placeholder="ชื่อเจ้าของที่ดิน"
                        type="text"
                        name="deed_name"
                        value={form.deed_name}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>เลขที่อ้างอิงเอกสารที่ดิน</Form.Label> */}
                      <FormControl
                        placeholder="เลขบัตรประชาชน"
                        type="text"
                        name="deed_idcard_number"
                        value={form.deed_idcard_number}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_idcard_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_idcard_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>จำนวนไร่</Form.Label> */}
                      <FormControl
                        placeholder="ขนาดพื้นที่(ไร่)"
                        type="number"
                        name="deed_rai"
                        value={form.deed_rai}
                        onChange={(e) => setDeed(e.target, e.target.value)}
                        isInvalid={!!errors.deed_rai}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deed_rai}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="auto">
                    <Form.Group>
                      <button
                        className="btn btn-primary btn-add-detail"
                        onClick={handleAddPlant}
                      >
                        เพิ่ม
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {plant.map((item, key) => {
                    return (
                      <div key={key}>
                        <li className="cademy-ui" key={key} name={key}>
                          {"เลขบัตรประชาชน : " +
                            item.deed_idcard_number +
                            "เลขที่ดิน : " +
                            item.deed_number +
                            " ประเภท : " +
                            item.deed_type +
                            " การเช่า : " +
                            item.deed_rent +
                            " ชื่อเจ้าของที่ดิน : " +
                            item.deed_name +
                            " เนื้อที่ : " +
                            item.deed_rai +
                            " ไร่"}
                          <i
                            className="bi bi-x"
                            key={key}
                            onClick={() => handleRemoveItemPlant(key)}
                            style={{ color: "red" }}
                          ></i>
                        </li>
                      </div>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <Form.Group controlId="IndustryStatus">
            <Form.Check
              type="checkbox"
              label="ขอยืนยันว่าได้ลงทะเบียนในระบบ I-industry เรียบร้อยแล้ว"
              name="industry_status"
              value="true"
              checked={industryStatus === "true"}
              onChange={handleCheckboxChange}
            />
          </Form.Group>
          <div>
            <Form.Group>
              <Form.Select
                name="approve_status"
                value={approveStatus || ""}
                onChange={(e) => setApprove_Status(e.target.value)}
                // isInvalid={!!errors.academy}
              >
                <option value="ฉบับร่าง">ฉบับร่าง</option>
                <option value="รออนุมัติ">รออนุมัติ</option>
              </Form.Select>
            </Form.Group>
          </div>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            // type="submit"
            onClick={handleSubmit}
            disabled={industryStatus === "false"}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAddDetail;

ModalAddDetail.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  farmer_idcard: PropTypes.number,
  academy: PropTypes.array,
  selectdata: PropTypes.object,
  data: PropTypes.array,
  setdata: PropTypes.func,
};

ModalAddDetail.defaultProps = {
  farmer_idcard: 0,
};
